
import React from 'react';

const EmptyState = () => {
  return (
    <div className="text-center p-8 border rounded-lg bg-muted/20">
      <p className="text-muted-foreground">
        No messages yet. Paste a seller response or start a new conversation.
      </p>
    </div>
  );
};

export default EmptyState;
